import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomatheraninnova() {



const cardData = {
keyword: "Pune to Matheran Innova Crysta Cab Booking",
headingDescription: "Plan a comfortable journey from Pune to Matheran with a spacious Innova Crysta cab from Citysky Cabs. The service is suitable for families, friends and groups planning a hill-station holiday, weekend getaway, sightseeing tour or one-day trip. With air-conditioned interiors, comfortable seating, useful luggage space and private driver support, travellers can conveniently reach the Matheran region while enjoying a relaxed road journey and flexible travel arrangements.",
topPlaces: [
{
title: "Matheran",
description: "Matheran is a popular hill station in Maharashtra known for its pleasant climate, forested surroundings and scenic viewpoints. A private Innova Crysta from Pune provides comfortable transportation to the Matheran region, making it suitable for families and groups planning a weekend or one-day getaway."
},
{
title: "Louisa Point",
description: "Louisa Point is one of Matheran's well-known viewpoints and offers scenic views across the surrounding landscape. Travellers can use a private cab to reach the Matheran area comfortably and then explore the hill station's designated sightseeing points according to local access arrangements."
},
{
title: "Panorama Point",
description: "Panorama Point is a popular Matheran attraction appreciated for its wide natural views and peaceful surroundings. A Pune to Matheran Innova Crysta journey provides convenient road transportation up to the permitted vehicle-access area, after which visitors can continue their local sightseeing through available Matheran travel options."
},
{
title: "Echo Point",
description: "Echo Point is a frequently visited scenic location in Matheran surrounded by greenery and hill landscapes. Travellers planning a Matheran sightseeing trip can use a private Innova Crysta for the Pune-to-Matheran road journey and organize local exploration after reaching the designated vehicle-access point."
},
{
title: "Charlotte Lake",
description: "Charlotte Lake is a peaceful natural attraction in Matheran and an important stop for visitors exploring the hill station. A private cab makes the journey from Pune convenient for families and groups, while local Matheran transportation can be used for sightseeing within the vehicle-restricted area."
},
{
title: "One Tree Hill Point",
description: "One Tree Hill Point is known for its elevated location and scenic views of the surrounding hills. Travellers can include it in their Matheran sightseeing itinerary after reaching the destination through a comfortable private Innova Crysta journey from Pune."
},
{
title: "Monkey Point",
description: "Monkey Point is a popular viewpoint in Matheran offering visitors an opportunity to enjoy the hill station's natural surroundings. The Innova Crysta is useful for the road journey from Pune, especially for families and groups carrying luggage for a weekend stay."
},
{
title: "Alexander Point",
description: "Alexander Point is a scenic Matheran viewpoint surrounded by greenery and mountain landscapes. A private cab journey from Pune allows families and groups to travel together comfortably before exploring the hill station through its permitted local transportation and walking routes."
},
{
title: "Panvel",
description: "Panvel is an important town on the route toward Matheran and can be included as a convenient stop during a broader travel itinerary. An Innova Crysta provides comfortable road transportation for passengers who want to combine their Matheran trip with nearby destinations."
},
{
title: "Karjat",
description: "Karjat is a scenic destination in the Raigad region known for greenery, hills and nearby outdoor attractions. Travellers planning an extended Matheran trip can include Karjat in their itinerary while using a private Innova Crysta for comfortable transportation between destinations."
}
],
services: [
{
name: "Pune to Matheran Innova Crysta Cab",
description: "Pune to Matheran Innova Crysta Cab provides spacious private transportation for families and groups travelling to the popular hill station. The air-conditioned cabin, comfortable seating and practical luggage capacity make it suitable for weekend trips, sightseeing plans and one-day outings."
},
{
name: "Pune to Matheran Innova Crysta Taxi",
description: "Pune to Matheran Innova Crysta Taxi offers a convenient private vehicle for travellers heading toward Matheran. The service is suitable for families, friends and small groups who want comfortable road travel with a dedicated driver for their hill-station journey."
},
{
name: "Pune Matheran Innova Crysta Booking",
description: "Pune Matheran Innova Crysta Booking allows travellers to reserve a spacious vehicle for their planned Matheran visit. The private cab can accommodate families and groups while providing comfortable seating, luggage space and convenient pickup and return arrangements."
},
{
name: "Pune Matheran Innova Crysta Rental",
description: "Pune Matheran Innova Crysta Rental provides a practical private travel option for passengers planning a Matheran holiday or sightseeing trip. The spacious vehicle is suitable for families and groups carrying luggage for a day trip or weekend stay."
},
{
name: "Pune to Matheran Innova Crysta on Rent",
description: "Pune to Matheran Innova Crysta on Rent offers comfortable private transportation from Pune toward the Matheran region. With air conditioning, spacious seating and useful luggage capacity, the vehicle is suitable for families and groups travelling for leisure."
},
{
name: "Pune to Matheran Innova Crysta Hire",
description: "Pune to Matheran Innova Crysta Hire is suitable for travellers looking for a dedicated vehicle for their hill-station trip. The cab can be arranged for one-way travel, round trips, sightseeing plans or customized itineraries involving nearby destinations."
},
{
name: "Pune Matheran AC Innova Crysta Cab",
description: "Pune Matheran AC Innova Crysta Cab provides a climate-controlled cabin for a comfortable road journey from Pune to the Matheran region. The spacious interiors make it practical for families, senior passengers and groups travelling together."
},
{
name: "Pune Matheran Luxury Innova Crysta Cab",
description: "Pune Matheran Luxury Innova Crysta Cab offers a premium-feel private travel arrangement for travellers visiting the hill station. Comfortable seating, air conditioning and a spacious cabin provide a convenient journey for families and groups planning a leisure getaway."
},
{
name: "Pune to Matheran 7 Seater Innova Crysta",
description: "Pune to Matheran 7 Seater Innova Crysta is suitable for families and small groups travelling together from Pune. The vehicle provides comfortable passenger seating and useful luggage space, making it practical for both one-day visits and weekend holidays."
},
{
name: "Pune Matheran One Way Innova Crysta Cab",
description: "Pune Matheran One Way Innova Crysta Cab is useful for passengers who need private transportation from Pune to the Matheran region without a standard return booking. The spacious Innova Crysta provides a comfortable long-distance transfer for families and groups."
},
{
name: "Pune Matheran Round Trip Cab",
description: "Pune Matheran Round Trip Cab provides convenient transportation from Pune to Matheran and back, making it suitable for travellers planning a complete hill-station outing. The private cab helps coordinate the return journey after sightseeing and leisure activities."
},
{
name: "Pune Matheran Outstation Innova Crysta",
description: "Pune Matheran Outstation Innova Crysta provides a spacious vehicle for travelling outside Pune toward Matheran. It is suitable for families and groups requiring comfortable seating, air conditioning, luggage capacity and dedicated driver support."
},
{
name: "Pune Matheran Family Trip Cab",
description: "Pune Matheran Family Trip Cab offers private transportation for families planning a relaxing hill-station getaway. The Innova Crysta provides comfortable seating and practical luggage space for parents, children and senior family members travelling together."
},
{
name: "Pune Matheran Group Travel Cab",
description: "Pune Matheran Group Travel Cab is suitable for friends, relatives and small groups visiting Matheran together. A spacious Innova Crysta allows passengers to remain together in one private vehicle while enjoying a comfortable journey from Pune."
},
{
name: "Affordable Pune Matheran Innova Crysta Cab",
description: "Affordable Pune Matheran Innova Crysta Cab provides a practical private travel option for passengers planning a Matheran getaway. The service combines comfortable seating, air conditioning, luggage space and dedicated transportation for families and groups."
},
{
name: "Pune Matheran Weekend Trip Cab",
description: "Pune Matheran Weekend Trip Cab is designed for travellers planning a short escape from Pune to the hill station. A private Innova Crysta gives families and groups convenient transportation for their journey while leaving flexibility for sightseeing and nearby stops."
},
{
name: "Pune Matheran Sightseeing Cab",
description: "Pune Matheran Sightseeing Cab is suitable for travellers who want to explore Matheran and nearby attractions as part of their trip. The private cab provides comfortable road transportation from Pune and can support a broader itinerary involving Karjat or Panvel."
},
{
name: "Pune Matheran Tourist Cab",
description: "Pune Matheran Tourist Cab provides private transportation for visitors planning to explore the hill station. The spacious Innova Crysta is suitable for families and groups travelling with luggage and looking for a comfortable road journey from Pune."
},
{
name: "Pune Matheran Innova Crysta Taxi Service",
description: "Pune Matheran Innova Crysta Taxi Service offers a spacious and air-conditioned vehicle for travelling from Pune to the Matheran region. The service is suitable for family trips, weekend outings, sightseeing plans and private group travel."
},
{
name: "Pune Matheran Innova Crysta Cab Near Me",
description: "Pune Matheran Innova Crysta Cab Near Me is useful for travellers searching for convenient private transportation for their Matheran trip. An Innova Crysta provides comfortable seating and useful luggage space for families and groups starting their journey from Pune."
},
{
name: "Pune Matheran Private Cab",
description: "Pune Matheran Private Cab allows travellers to enjoy a dedicated vehicle without sharing the journey with unrelated passengers. Families and groups can coordinate pickup, travel timing, sightseeing plans and return arrangements according to their own requirements."
},
{
name: "Pune Matheran Innova Crysta Cab Hire",
description: "Pune Matheran Innova Crysta Cab Hire provides a spacious private vehicle for travellers planning a hill-station holiday. The service is suitable for families and groups who want comfortable road transportation with flexible arrangements for their Matheran itinerary."
},
{
name: "Pune Matheran Rental Car with Driver",
description: "Pune Matheran Rental Car with Driver offers convenient driving support for passengers travelling from Pune to Matheran. The Innova Crysta provides comfortable seating and luggage capacity while the dedicated driver handles the road journey."
},
{
name: "Pune Matheran Family Tour Cab",
description: "Pune Matheran Family Tour Cab provides spacious private transportation for families planning to explore the hill station together. The Innova Crysta is suitable for carrying luggage and travelling comfortably during a one-day visit or longer family holiday."
},
{
name: "Pune Matheran One Day Trip Innova Crysta",
description: "Pune Matheran One Day Trip Innova Crysta is suitable for travellers planning a complete same-day outing from Pune. The spacious private vehicle provides comfortable road transportation while allowing the group to organize its Matheran sightseeing schedule conveniently."
}
],
tableData: [
["Pune to Matheran Innova Crysta Cab"],
["Pune to Matheran Innova Crysta Taxi"],
["Pune Matheran Innova Crysta Booking"],
["Pune Matheran Innova Crysta Rental"],
["Pune to Matheran Innova Crysta on Rent"],
["Pune to Matheran Innova Crysta Hire"],
["Pune Matheran AC Innova Crysta Cab"],
["Pune Matheran Luxury Innova Crysta Cab"],
["Pune to Matheran 7 Seater Innova Crysta"],
["Pune Matheran One Way Innova Crysta Cab"],
["Pune Matheran Round Trip Cab"],
["Pune Matheran Outstation Innova Crysta"],
["Pune Matheran Family Trip Cab"],
["Pune Matheran Group Travel Cab"],
["Affordable Pune Matheran Innova Crysta Cab"],
["Pune Matheran Weekend Trip Cab"],
["Pune Matheran Sightseeing Cab"],
["Pune Matheran Tourist Cab"],
["Pune Matheran Innova Crysta Taxi Service"],
["Pune Matheran Innova Crysta Cab Near Me"],
["Pune Matheran Private Cab"],
["Pune Matheran Innova Crysta Cab Hire"],
["Pune Matheran Rental Car with Driver"],
["Pune Matheran Family Tour Cab"],
["Pune Matheran One Day Trip Innova Crysta"]
],
whychoose: [
{
WhyChooseheading: "Comfortable Hill Station Travel",
WhyChoosedescription: "The Innova Crysta provides spacious seating and an air-conditioned cabin for the road journey from Pune toward Matheran. It is a practical choice for families and groups who want to travel comfortably during a leisure or weekend trip."
},
{
WhyChooseheading: "Suitable for Families and Groups",
WhyChoosedescription: "Families, friends and small groups can travel together in one spacious private vehicle. The arrangement helps keep everyone together while providing sufficient space for personal belongings during a day trip or weekend stay."
},
{
WhyChooseheading: "Private Door-to-Destination Journey",
WhyChoosedescription: "A dedicated cab provides convenient transportation from the Pune pickup point toward the Matheran region without sharing the vehicle with unrelated passengers. This makes the road journey easier to coordinate around the group's preferred schedule."
},
{
WhyChooseheading: "Weekend Getaway Convenience",
WhyChoosedescription: "Matheran is suitable for a short escape from Pune, and a private Innova Crysta makes the journey convenient for weekend travellers. The spacious vehicle also provides useful room for bags and belongings needed during an overnight stay."
},
{
WhyChooseheading: "Flexible One-Day Trip Planning",
WhyChoosedescription: "Travellers planning a same-day Matheran visit can use a private cab to coordinate their departure and return schedule. The arrangement allows the group to manage its sightseeing time without depending on fixed shared transport."
},
{
WhyChooseheading: "Comfortable Luggage Capacity",
WhyChoosedescription: "The Innova Crysta offers practical luggage space for families carrying bags and personal belongings for a hill-station trip. This is especially useful for weekend journeys where passengers need additional luggage compared with a short local outing."
},
{
WhyChooseheading: "Dedicated Driver Support",
WhyChoosedescription: "A dedicated driver manages the road journey while passengers can focus on enjoying their trip. This can be useful for travellers unfamiliar with the Pune-Matheran route and those planning additional stops around Karjat or Panvel."
},
{
WhyChooseheading: "Convenient for Nearby Sightseeing",
WhyChoosedescription: "Private transportation provides flexibility for travellers who want to combine Matheran with suitable nearby destinations. The journey can be planned around the group's sightseeing preferences while maintaining comfortable travel between the selected road-access locations."
}
]
};







const faqData = [
{
question: "Can I book an Innova Crysta from Pune to Matheran?",
answer: "Travellers planning a getaway from Pune to Matheran can enquire about an Innova Crysta cab for the journey. Citysky Cabs can coordinate the trip according to your pickup point, travel date, passenger count, luggage requirements, preferred departure time, and return plan."
},
{
question: "Is an Innova Crysta suitable for a family trip to Matheran?",
answer: "Families travelling from Pune to Matheran can consider an Innova Crysta when they prefer a private vehicle for the journey. It allows parents, children, and relatives to travel together while keeping luggage and personal belongings organized during the trip."
},
{
question: "Can I hire an Innova Crysta for a Pune to Matheran weekend trip?",
answer: "A private Innova Crysta can be considered for a weekend getaway to Matheran from Pune. The travel arrangement can be planned around your preferred departure and return dates, hotel schedule, passenger count, luggage, and other requirements for the short holiday."
},
{
question: "Can I book a round-trip Innova Crysta from Pune to Matheran?",
answer: "Travellers who want transportation for both the onward and return journey can enquire about a round-trip Innova Crysta. Sharing your travel dates, expected stay duration, pickup location, number of passengers, and preferred return timing helps Citysky Cabs coordinate the booking."
},
{
question: "Can I travel from Pune to Matheran with children in an Innova Crysta?",
answer: "Families travelling with children can choose a private Innova Crysta for their Matheran trip when they want everyone to remain together during the road journey. The group can plan its departure around the children's schedule and carry the necessary travel bags and belongings."
},
{
question: "Can I book an Innova Crysta for a Matheran sightseeing trip?",
answer: "An Innova Crysta can be arranged for groups travelling from Pune to Matheran for a holiday and sightseeing program. Citysky Cabs can coordinate the road transportation around your planned stay, sightseeing schedule, passenger count, and return requirements."
},
{
question: "Can senior citizens travel from Pune to Matheran by Innova Crysta?",
answer: "Groups travelling with senior family members can discuss a private Innova Crysta arrangement for the Pune to Matheran journey. Having dedicated transportation allows the group to manage the road trip according to its own timing and plan suitable breaks along the way."
},
{
question: "Can I carry luggage in an Innova Crysta for my Matheran trip?",
answer: "Travellers can share their approximate luggage details while enquiring about the cab. This is helpful for families and groups carrying holiday bags, personal belongings, children's items, or luggage for a multi-day stay in Matheran."
},
{
question: "Can I combine Matheran with another destination from Pune?",
answer: "Travellers interested in extending their trip beyond Matheran can discuss a customized itinerary with Citysky Cabs. Additional destinations can be considered according to the available travel days, route, passenger count, sightseeing plans, and preferred return schedule."
},
{
question: "How can I book a Pune to Matheran Innova Crysta Cab with Citysky Cabs?",
answer: "To enquire about an Innova Crysta booking, provide your Pune pickup location, Matheran travel date, passenger count, luggage requirements, preferred departure time, stay duration, and whether you need one-way or return transportation. Citysky Cabs can coordinate the cab according to your holiday itinerary."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Akash Gawande",
feedback:
"We planned a weekend Matheran trip from Pune with our parents and children and wanted everyone to travel in one vehicle. The Innova Crysta worked well for our group and luggage. Citysky Cabs coordinated the pickup according to our planned departure, which made the start of our holiday quite smooth.",
rating: 5
},
{
id: 2,
name: "Miss. Riya Kulkarni",
feedback:
"A few friends planned a short Matheran getaway and we decided to hire an Innova Crysta instead of taking multiple cars. Travelling together made the road journey more enjoyable and easier to coordinate. The booking with Citysky Cabs was handled clearly, and the cab arrangement suited the schedule we had shared.",
rating: 5
}
];
















































    const Images = [

    { place: "/images/keyword/1.jpg", text: "Innova Crysta Cab in Pune", link: "innova-crysta-cab-in-pune" },

    { place: "/images/keyword/2.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },

    { place: "/images/keyword/3.jpg", text: "Innova Crysta Cabs / Taxi Booking in Pune", link: "innova-crysta-cabs-taxi-booking-in-pune" },

    { place: "/images/keyword/4.jpg", text: "Pune to Mahabaleshwar Innova Crysta Cab", link: "pune-to-mahabaleshwar-innova-crysta-cab" },

    { place: "/images/keyword/5.jpg", text: "Book Innova Crysta for Outstation From Pune", link: "book-innova-crysta-for-outstation-from-pune" },

    { place: "/images/keyword/6.jpg", text: "Innova Crysta Cabs for Pune Airport", link: "innova-crysta-cabs-for-pune-airport" },

    { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Airport Innova Crysta", link: "pune-to-mumbai-airport-innova-crysta" },

    { place: "/images/keyword/8.jpg", text: "Innova Crysta Cab for Corporate Office", link: "innova-crysta-cab-for-corporate-office" },

    { place: "/images/keyword/9.jpg", text: "Mumbai Airport to Pune Innova Crysta Cabs", link: "mumbai-airport-to-pune-innova-crysta-cabs" },

    { place: "/images/keyword/10.jpg", text: "Pune to Shirdi Innova Crysta", link: "pune-to-shirdi-innova-crysta" },

    { place: "/images/keyword/11.jpg", text: "Pune Aurangabad Innova Crysta Cab Service", link: "pune-aurangabad-innova-crysta-cab-service" },

    { place: "/images/keyword/12.jpg", text: "Pune to Goa Innova Crysta Cab", link: "pune-to-goa-innova-crysta-cab" },

    { place: "/images/keyword/13.jpg", text: "Pune to Bangalore Innova Crysta Cab", link: "pune-to-bangalore-innova-crysta-cab" },

    { place: "/images/keyword/14.jpg", text: "Pune to Hyderabad Innova Crysta Rental Cab", link: "pune-to-hyderabad-innova-crysta-rental-cab" },

    { place: "/images/keyword/15.jpg", text: "Innova Crysta on Rent in Pune", link: "innova-crysta-on-rent-in-pune-2" },

    { place: "/images/keyword/16.jpg", text: "Pune to Lavasa Innova Crysta Cab Booking", link: "pune-to-lavasa-innova-crysta-cab-booking" },

    { place: "/images/keyword/17.jpg", text: "Pune Darshan Innova Crysta Cabs", link: "pune-darshan-innova-crysta-cabs" },

    { place: "/images/keyword/18.jpg", text: "Innova Crysta Cabs in Pune", link: "innova-crysta-cabs-in-pune" },

    { place: "/images/keyword/19.jpg", text: "Innova Car Rental In Pune", link: "innova-car-rental-in-pune" },

    { place: "/images/keyword/20.jpg", text: "Innova Taxi Service in Pune", link: "innova-taxi-service-in-pune" },

    { place: "/images/keyword/21.jpg", text: "Book Innova for Outstation Pune", link: "book-innova-for-outstation-pune" },

    { place: "/images/keyword/22.jpg", text: "Innova Crysta On Rent In Pune", link: "innova-crysta-on-rent-in-pune-3" },

    { place: "/images/keyword/23.jpg", text: "Pune to Mahabaleshwar Panchgani Innova Crysta Cabs", link: "pune-to-mahabaleshwar-panchgani-innova-crysta-cabs" },

    { place: "/images/keyword/24.jpg", text: "Pune to Outstation Innova Crysta Booking", link: "pune-to-outstation-innova-crysta-booking" },

    { place: "/images/keyword/25.jpg", text: "Innova Crysta on Rent in Pune", link: "innova-crysta-on-rent-in-pune-4" },


];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Matheran Innova Crysta Cab Booking",
  "image": "https://www.cityskycab.in/assets/images/pune-to-matheran-innova-crysta-cab-booking.webp",
  "description": "Pune to Matheran Innova Crysta Cab Booking from Citysky Cabs is a comfortable private travel option for families, friends and groups planning a hill-station trip from Pune to Matheran. The service covers Pune to Matheran Innova Crysta Cab, Innova Crysta Taxi, booking, rental and on-rent requirements, with spacious AC seating suitable for a relaxed road journey. The Innova Crysta offers useful luggage capacity and comfortable seating for passengers travelling together, making it practical for weekend getaways, family holidays, resort stays and sightseeing plans. Customers can arrange one-way or return travel according to their itinerary, with pickup from Pune and the vehicle planned around the preferred travel date, passenger group and journey schedule.",
  "brand": {
    "@type": "Brand",
    "name": "Citysky Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.cityskycab.in/pune-to-matheran-innova-crysta-cab-booking"
  }
};








    return (
        <div>

<Helmet>
  <title>
    Pune to Matheran Innova Crysta Cab Booking | Pune Matheran AC Crysta for Hill Station Trips | +91 8554819191
  </title>

  <meta
    name="description"
    content="Travel from Pune to Matheran in a spacious AC Innova Crysta with Citysky Cabs. Ideal for family holidays, weekend getaways, resort travel and comfortable one-way or return journeys."
  />

  <meta
    name="keywords"
    content="Pune to Matheran Innova Crysta Cab, Pune to Matheran Innova Crysta Taxi, Pune Matheran Innova Crysta Booking, Pune Matheran Innova Crysta Rental, Pune to Matheran Innova Crysta on Rent, Pune to Matheran Innova Crysta Hire, Pune Matheran AC Innova Crysta Cab, Pune Matheran Luxury Innova Crysta Cab, Pune to Matheran 7 Seater Innova Crysta, Pune Matheran One Way Innova Crysta Cab, Pune Matheran Round Trip Innova Crysta Cab, Pune to Matheran Innova Crysta Cab Booking, Pune Matheran Innova Crysta Cab Service, Pune Matheran Hill Station Taxi, Pune Matheran Family Cab, Pune Matheran Weekend Cab, Pune Matheran Outstation Cab, Pune Matheran Private Innova Crysta, Pune Matheran Resort Transfer Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div className="sisf-banner sis-br-radius mt-3 position-relative">
                <div className="banner-img">
                    <figure>
                      {/* <img
                            src="/images/page-banner.jpg"
                            alt="Mauliwala Travels Urbania and Mini Bus Rental Pune"
                        /> */}
                    </figure>
                </div>

                <div className="sisf-page-title sisf-m sisf-title--standard sisf-alignment--center">
                    <div className="sisf-m-inner container">
                        <div className="sisf-m-content sisf-content-grid">
                            <h1 className="sisf-m-title text-white sis-text-anime-style-3 entry-title">
                                {cardData.keyword}
                            </h1>
                        </div>
                    </div>
                </div>
            </div>














            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/57.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Citysky Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Citysky Cabs</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Citysky Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918554819191" className="pc-call">+91 8554819191 </a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+918459883515" className="pc-call">+91 8459883515 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918459883515
"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918459883515" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@cityskycab.in" className="pc-email">
                                            booking@cityskycab.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Citysky Cabs</strong><br />

                                            Office No,307,3rd Floor,
                                            52, Sinhgad Rd, Wadgaon Budruk,
                                            Narhe, Pune, Maharashtra,India- 411041.






                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetomatheraninnova;